import OrderDetailsForm from "./orderDetailsForm.container";

export default OrderDetailsForm;
